import axios from "axios";
// import { getToken } from '@/utils/auth';
import store from "@/store";
// import * as JSONbig from "json-bigint";
var JSONbig = require("json-bigint");
const _json = JSONbig({
  storeAsString: true,
});
// 默认配置  转换响应数据
axios.defaults.transformResponse = [
  (data) => {
    if (typeof data == "string") {
      // 对data（后台的原始数据）进行转换
      return _json.parse(data);
    } else {
      return data;
    }
  },
];
// import store from '../../store/index';
/* eslint-disable */

// console.log('env', process.env);

// axios.defaults.url = process.env.VUE_APP_LIVE_API_URL;
// console.log(axios.defaults.baseURL);
// let
// 添加请求拦截器
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params, options, type) {
  let setOptions = Object.assign(options || {}, {
    // headers: {
    //   sid: store.getters.sid,
    // },
  });

  return new Promise((resolve, reject) => {
    axios
      .get(url + params, setOptions)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getJson(url, params, headers = {}, others = {}) {
  let paramsInfo = {
    params,
    headers: url.includes(config.incurt)
      ? Object.assign(
          {},
          {
            sid: store.getters.sid,
          },
          headers,
        )
      : Object.assign(
          {},
          {
            sid: store.getters.sid,
            token: store.getters.sid,
          },
          headers,
        ),
    ...others,
  };
  return new Promise((resolve, reject) => {
    axios
      .get(url, paramsInfo)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function getResponseType(url, responseType, params) {
  return new Promise((resolve, reject) => {
    axios({ url, responseType, params, method: "get" })
      .then((res) => {
        console.log(res);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 返回值如下：
 */
export function post(url, params, headers = {}, others = {}) {
  // console.log(store.state);
  let paramsInfo = {
    headers: url.includes(config.incurt)
      ? Object.assign(
          {},
          {
            sid: store.getters.sid,
          },
          headers,
        )
      : Object.assign(
          {},
          {
            sid: store.getters.sid,
            token: store.getters.sid,
          },
          headers,
        ),
    ...others,
  };
  // let postUrl = `${cavcURL}${url}`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, paramsInfo)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        if (err.status == "201") {
          resolve(err.data);
        } else {
          reject(err.data);
          console.log("err post error", err);
        }
      });
  });
}

/**
 * put方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 返回值如下：
 */
export function put(url, params, headers = {}) {
  let setOptions = Object.assign(
    {},
    {
      headers: Object.assign(
        {},
        {
          sid: store.getters.sid,
        },
        headers,
      ),
    },
  );
  return new Promise((resolve, reject) => {
    axios
      .put(url, params, setOptions)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 返回值如下：
 */
export function storePost(url, params, options) {
  // console.log(storeURl);
  let setOptions = Object.assign(options || {}, {
    headers: {
      sid: store.getters.sid,
      "Content-Type": "multipart/form-data;charset=UTF-8",
    },
  });
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, setOptions)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * deleteMethod方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 返回值如下：
 */
export function deleteMethod(url, headers = {}) {
  let paramsInfo = {
    headers: Object.assign(
      {},
      {
        sid: store.getters.sid,
      },
      headers,
    ),
  };
  console.log(paramsInfo);
  return new Promise((resolve, reject) => {
    axios
      .delete(url, paramsInfo)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
